import React from 'react';
import { useSelector } from 'react-redux';

import { MultiSelect } from 'primereact/multiselect';
import { checkPermissions } from '../utils';
import PermDetailsWrapper from '../common/PermDetailsWrapper';

        
function MultiSelectField(props) {
    const userDetails = useSelector(state => state.userDetails)

    const labelText = props.labelText ? props.labelText : ""

    const placeholder = props.placeholder ? props.placeholder : ""

    const options = props.options ? props.options : []
    const optionLabel = props.optionLabel ? props.optionLabel : ""
    const optionValue = props.optionValue ? props.optionValue : ""
    const value = props.value ? props.value : []
    const name = props.name ? props.name : ""
    const itemTemplate = props.itemTemplate ? props.itemTemplate : null
    const className = props.className ? props.className : "w-100"

    const handleOnchange = (e) => {
        if(props.onChange){
            props.onChange(e)
        }
    }

    const permissions = props.permissions ? props.permissions : []
    const permParameters = props.permParameters ? props.permParameters : {}

    let disabled = false 
    let isPermitted = false
    let permittedCompanyRoleIds = []
    let permittedExceptionUserRoleIds = []
    let permittedExceptionNegitiveUserRoleIds = []

    if(permissions.length){
        console.log("permissions input", permissions)
        const permParams = {
            reqPermActionIds: permissions,
            permParameters: permParameters,
            activeCompanyRoleId: userDetails.activeCompanyRoleId,
            userRoleId: userDetails.activeRoleId,
            permExceptions: userDetails.permExceptions,
            permGeo: userDetails.permGeo,
            permActions: userDetails.permActions,
            permRoles: userDetails.permRoles,
            companyRoles: userDetails.companyDetails.companyRoles
        }

        const permissionDetails = checkPermissions(permParams)
        isPermitted = permissionDetails.isPermitted
        permittedCompanyRoleIds = permissionDetails.permittedCompanyRoleIds
        permittedExceptionUserRoleIds = permissionDetails.permittedExceptionUserRoleIds
        permittedExceptionNegitiveUserRoleIds = permissionDetails.permittedExceptionNegitiveUserRoleIds

        if(!isPermitted){
            disabled = true
        }
    }

    if(props.disabled){
        disabled = true
    }

    const renderMultiSelect = () => (
        <>
            { labelText ? <label htmlFor="" style={{fontSize: '12px', marginBottom: '3px'}}>{labelText}{ props.required && <span style={{color:"red"}}>*</span> }</label> : "" }
            <MultiSelect name = {name} className={className} options={options} optionLabel={optionLabel} optionValue={optionValue} itemTemplate={itemTemplate} value={value} placeholder={placeholder} onChange={(e) => handleOnchange(e)} disabled={disabled} optionDisabled={props.optionDisabled}
                 display={!props.maxSelectedLabels && !props.selectedItemsLabel ? 'chip' : 'comma'}
                 maxSelectedLabels={props.maxSelectedLabels}
                 selectedItemsLabel={props.selectedItemsLabel}
                />
            { props.errorMessage && <small className='p-error' style={{fontSize: 'x-small', marginTop: '0.25rem'}}>{props.errorMessage}</small> }
        </>
    );

    return (
        <PermDetailsWrapper
            displayComponent={renderMultiSelect()}
            uniqueId={labelText}
            permissions={permissions}
            permittedCompanyRoleIds={permittedCompanyRoleIds}
            permittedExceptionUserRoleIds={permittedExceptionUserRoleIds}
            permittedExceptionNegitiveUserRoleIds={permittedExceptionNegitiveUserRoleIds}
            visible={!props.disabled && !isPermitted}
        />
    )
}

export default MultiSelectField;